import { Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { Device } from '../../_provider/devices/device.type';
import { DevicesService } from 'src/app/_provider/devices/devices.service';
import { HttpFunctionResult } from 'src/app/_interfaces/HttpFunctionResult';
import { InfiniteScrollCustomEvent, IonInfiniteScroll, ModalController } from '@ionic/angular';

const DEVICE_LIMIT = 10

@Component({
    selector: 'app-device-select',
    templateUrl: './device-select.page.html',
    styleUrls: ['./device-select.page.scss'],
    standalone: false
})
export class DeviceSelectPage implements OnInit {

  @ViewChild(IonInfiniteScroll, {static: true}) infiniteScroll: IonInfiniteScroll

  public devices: Device[] = []

  public addressId: number = -1

  public searchText: string = ""
  public onlyThisAddress: boolean = true
  public isLoading: boolean = true

  public offset: number = 0

  public infiniteDisabled: boolean = false

  constructor(
    private deviceSrv: DevicesService,
    private modalCtrl: ModalController,
    private ngZone: NgZone
  ) { }

  async ngOnInit() {
    await this.loadDevices()
  }

  public async loadDevices(){    

    this.isLoading = true
    this.offset = 0

    const result: HttpFunctionResult<Device[]> = await this.getDevices()

    this.ngZone.run(() => {
      this.isLoading = false
      if(!result.success) return
      this.devices = result.data
      this.infiniteDisabled = result.data.length < DEVICE_LIMIT
    })
    

  }

  private async getDevices(): Promise<HttpFunctionResult<Device[]>>{
    return await this.deviceSrv.getAllDevices(
      this.searchText, 
      this.onlyThisAddress ? this.addressId : -1,
      this.offset,
      DEVICE_LIMIT
    )
  }

  public async close(){
    await this.modalCtrl.dismiss()
  }

  private searchTimeout: any
  public async searchChanged(){
    if(this.searchTimeout) clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(async ()=>{
      await this.loadDevices()
    }, 350)
  }

  public async onIonInfinite(event: InfiniteScrollCustomEvent){
    
    this.offset += DEVICE_LIMIT
    const result: HttpFunctionResult<Device[]> = await this.getDevices()

    this.ngZone.run(() => {
      event.target.complete()
      if(!result.success) return
      this.devices = [...this.devices, ...result.data]
      if(result.data.length < DEVICE_LIMIT) this.infiniteDisabled = true
    })

  }

  public async selectDevice(device: Device){
    await this.modalCtrl.dismiss(device)
  }

}
